import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { setAlertMsg } from '../../../redux/reducers/modal/snackBarSlice';
import { setModal } from '../../../redux/reducers/modal/modalSlice';
import { removePromoCode } from '../../../controllers/settings/promo/removePromoCode';

export default function RemovePromoModal({id,returnData}) {
  const [loading,setLoading] = useState();
 
  const dispatch = useDispatch();
  

  async function handleRemove() {
    setLoading(true);
    const res = await removePromoCode(id);
    setLoading(false);
    if(res.return) {
      dispatch(setAlertMsg(['success','Promo code removed']))
      if(returnData)
        returnData();
    }
    else dispatch(setAlertMsg(['error','Unable to remove promo code!']))

    dispatch(setModal(false));
    // console.log('removing',id)
  } 
  return (
    <div className='h-full flex items-center'>
      <div className='flex flex-col bg-secondary rounded-md p-5 pt-10 items-center gap-5 relative'>
        <div className='btn_close' onClick={() => dispatch(setModal(false))}>X</div>
        <div>Are you sure you want to remove Promo Code?</div>
        <button className='btn2 flex gap-2' disabled={loading} onClick={handleRemove}>
          {loading?(<div className='load'></div>):null}
          Yes, Remove.
        </button>
      </div>
    </div>
  )
}
